import { Heading } from '@cognite/cogs-core-v11/tokens/typography/typography.tsx';
import { Loader } from '@cognite/cogs-core-v11/components/loader/loader.tsx';

export const PageLoader = ({ infoText }: { infoText: string }) => {
  return <Loader infoText={<Heading level={6}>{infoText}</Heading>} />;
};
